<script>
    import { createTag } from '@/api/tags.js';

    export default {
        computed: {
            isSave() {return this.$store.getters.IS_SAVE_TAG_ADD}
        },
        methods: {
            async create() {
                const response = await createTag(
                    this.$store.getters.TAG_DATA_ADD
                );
                if (response != null) {
                    this.$store.commit('TAGS_PUSH', response);
                    await this.close();
                }
            },
            async close() {
                this.$store.commit('IS_SHOW_TAG_ADD', false);
            }
        }
    }
</script>


<template>
    <button
        :disabled="isSave === false"
        class="button_blue_100"
        @click="create"
    >Create</button>
    <button
        class="button_blue_100 close_button mr_10"
        @click="close"
    >Close</button>
</template>